import type { NavigationGuard, RouteConfig, } from 'vue-router';

function loadNavigationGuard(name: keyof typeof import('./route-guards')): NavigationGuard {
	return (to, from, next) => {
		import('./route-guards').then((a) => {
			a[name](to, from, next);
		});
	};
}
export const MeterReadRoutes: RouteConfig[] = [
	{
		path: '/submit-meter-read',
		component: () => import(/* webpackChunkName: "chunk-your-account-meter-read" */'./pages/master.vue').then((m) => m.default),
		beforeEnter: loadNavigationGuard('LoadMeterDetails'),
		children: [
			{ path: `your-reading`, name: 'SubmitMeterReadingYourReading', component: () => import(/* webpackChunkName: "chunk-your-account-meter-read" */'./pages/your-reading.vue').then((m) => m.default), },
			{ path: `confirm-reading`, component: () => import(/* webpackChunkName: "chunk-your-account-meter-read" */'./pages/confirm-reading.vue').then((m) => m.default), beforeEnter: loadNavigationGuard('RequiresMeterReading'), },
			{ path: `success`, component: () => import(/* webpackChunkName: "chunk-your-account-meter-read" */'./pages/meter-read-success.vue').then((m) => m.default), },
			{ path: `successful`, component: () => import(/* webpackChunkName: "chunk-your-account-meter-read" */'./pages/meter-read-success.vue').then((m) => m.default), },
			{ path: `pending-read`, component: () => import(/* webpackChunkName: "chunk-your-account-meter-read" */'./pages/meter-read-pending.vue').then((m) => m.default), },
			{ path: '', redirect: 'your-reading', name: 'SubmitMeterReading', },
		],
	},
];
